module.exports = __webpack_public_path__ + "img/reddit-circle.bbd2710a.svg";